/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GoogleLandingPageCommercialContextData
 */
export interface GoogleLandingPageCommercialContextData {
    /**
     * 
     * @type {string}
     * @memberof GoogleLandingPageCommercialContextData
     */
    host?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleLandingPageCommercialContextData
     */
    erpOrders?: string;
    /**
     * ERP accounting turnover in project-currency minor units.
     * @type {string}
     * @memberof GoogleLandingPageCommercialContextData
     */
    erpTurnover?: string;
}

/**
 * Check if a given object implements the GoogleLandingPageCommercialContextData interface.
 */
export function instanceOfGoogleLandingPageCommercialContextData(value: object): value is GoogleLandingPageCommercialContextData {
    return true;
}

export function GoogleLandingPageCommercialContextDataFromJSON(json: any): GoogleLandingPageCommercialContextData {
    return GoogleLandingPageCommercialContextDataFromJSONTyped(json, false);
}

export function GoogleLandingPageCommercialContextDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoogleLandingPageCommercialContextData {
    if (json == null) {
        return json;
    }
    return {
        
        'host': json['host'] == null ? undefined : json['host'],
        'erpOrders': json['erpOrders'] == null ? undefined : json['erpOrders'],
        'erpTurnover': json['erpTurnover'] == null ? undefined : json['erpTurnover'],
    };
}

export function GoogleLandingPageCommercialContextDataToJSON(json: any): GoogleLandingPageCommercialContextData {
    return GoogleLandingPageCommercialContextDataToJSONTyped(json, false);
}

export function GoogleLandingPageCommercialContextDataToJSONTyped(value?: GoogleLandingPageCommercialContextData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'host': value['host'],
        'erpOrders': value['erpOrders'],
        'erpTurnover': value['erpTurnover'],
    };
}

